import Service from "../Service";
import Service2 from "../Service2";

const dataDev = {
  getAllDevData() {
    return Service.get(`/api/developerdata/all`);
  },
  getAllDevDataCkan() {
    return Service2.get(`/api/3/action/package_search?fq=groups:creative-economy`);
  },
  getDevDataCkan(group) {
    return Service2.get(`/api/3/action/package_search?fq=groups:${group}&rows=100`);
  },
  getGroupCkan() {
    return Service.get(`/api/groupCkan/all`);
  },
  getDataContent(id) {
    return Service.get(`/api/developerdata/${id}`);
  },
  getDataContentExcel(id) {
    return Service.get(`/api/developerdata/excelfile/${id}`);
  },
  addDevData(data) {
    return Service.post(`/api/developerdata/add`, data);
  },
  updateDevData(id, data) {
    return Service.put(`/api/developerdata/update/${id}`, data);
  },
  deleteDevData(id) {
    return Service.delete(`/api/developerdata/${id}`);
  },
  importExcel(data) {
    return Service.post(`/api/developerdata/import-excel`, data);
  },
};

export default dataDev;
